import React from "react";
import { Link, LinkProps} from "react-router-dom";

type WrappedLinkProps<S> = {
	children: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
} & LinkProps<S> &
	React.RefAttributes<HTMLAnchorElement>;

export default function WrappedLink<S>({
	to,
	children,
	onClick,
	...rest
}: WrappedLinkProps<S>) {
	const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
		if (
			!window.navigator.onLine ||
			location.pathname.includes("app-update")
		) {
			window.location.href =
				typeof to == "string"
					? to
					: typeof to == "object"
					? to.pathname || "/"
					: "/";
		}
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<Link to={to} onClick={handleClick} {...rest}>
			{children}
		</Link>
	);
}
